import clsx from 'clsx';
import React, { useState } from 'react';
import styles from './Alert.module.scss';
const defaultIconMapping = {
    success: 'https://www.haven.com/assets/owners/shared/tick_filled_green.svg',
    warning: 'https://www.haven.com/assets/owners/shared/warning_filled_yellow.svg',
    error: 'https://www.haven.com/assets/owners/shared/cross_filled_red.svg',
    info: 'https://www.haven.com/assets/owners/shared/info_filled_blue.svg',
};
export const Alert = ({ title, text, body, severity, dismissable = false, icon = null, className = null, onDismiss, }) => {
    const [isDismissed, setIsDismissed] = useState(false);
    const handleDismiss = () => {
        setIsDismissed(true);
        if (onDismiss) {
            onDismiss();
        }
    };
    if (isDismissed) {
        return null;
    }
    return (<div className={clsx(styles.root, className)}>
      <div className={styles.icon}>
        {icon ? icon : <img src={defaultIconMapping[severity]} alt='' role='presentation'/>}
      </div>
      <div className={styles.content}>
        <div className={styles.text}>
          <span className={styles.title}>{title}</span> <span>{text}</span>
          {body}
        </div>
      </div>
      {dismissable && (<button className={styles.closeButton} onClick={handleDismiss}>
          <img className={styles.closeIcon} src='https://www.haven.com/assets/icons/close.svg' alt='close' role='presentation'/>
        </button>)}
    </div>);
};
